var paginationOffset = ( state = 0, action ) => {
    if ( action.type === 'pagination' ) {
        return action.payload;
    } else {
        return state;
    }
}
export default paginationOffset;